<template>
  <Vertical v-if="useLayout.config.layoutType === 'vertical'">
    <slot />
  </Vertical>
  <Horizontal v-if="useLayout.config.layoutType === 'horizontal'">
    <slot />
  </Horizontal>
  <Detached v-if="useLayout.config.layoutType === 'detached'">
    <slot />
  </Detached>
</template>

<script lang="ts">
import Vertical from '@/views/components/layouts/vertical.vue'
import Horizontal from '@/views/components/layouts/horizontal.vue'
import Detached from '@/views/components/layouts/detached.vue'
import { useLayoutStore } from '@/stores/layout'
import { defineComponent } from 'vue'

export default defineComponent({
  components: { Detached, Horizontal, Vertical },
  setup() {
    const useLayout = useLayoutStore()

    return {
      useLayout,
    }
  },
})
</script>
